// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"8bd97881","425":"155d0a58","510":"048e384f","532":"414d80e7","633":"c836b3a3","634":"560b0e86","922":"e23d3340","937":"c7245cb6","972":"754654f0"}[chunkId] + ".chunk.js";
};